enum Font {
  Light = "Satoshi-Light",
  LightItalic = "Satoshi-LightItalic",
  Regular = "Satoshi-Regular",
  Italic = "Satoshi-Italic",
  Medium = "Satoshi-Medium",
  MediumItalic = "Satoshi-MediumItalic",
  Bold = "Satoshi-Bold",
  BoldItalic = "Satoshi-BoldItalic",
  Black = "Satoshi-Black",
  BlackItalic = "Satoshi-BlackItalic",
  Variable = "Satoshi-Variable",
  VariableItalic = "Satoshi-VariableItalic"
}

export enum FontDecoration {
  Underline = "underline"
}

export enum Spacing {
  TextAlignCenter = "center",
  Padded = "4rem"
}

export default Font;
